/* eslint-disable default-param-last */
/**
 * @description Reducer sobre as funções da edição de exame genéricos
 *  Exame genérico - todos os exames que não possuem ainda o modelo definitivo
 * @author Diego Sabino Amorim de Araújo
 * @file edicaoExame/exameGenericoReducer.js
 *
 * @license Copyright (c) 2022 SIGEP DIGETI ITEP/RN
 */

import types from 'utils/actionTypes'

const initialState = {
  exameGenerico: {
    historico: '',
    descricao: '',
    discussao: '',
    conclusao: '',
  },
  activeStep: 0,
}

const exameGenericoReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_EXAME_GENERICO: {
      return {
        ...state,
        exameGenerico: action.exameGenerico,
      }
    }

    case types.SET_ACTIVE_STEP_EXAME_GENERICO: {
      return {
        ...state,
        activeStep: action.activeStep,
      }
    }

    default: {
      return {
        ...state,
      }
    }
  }
}

export default exameGenericoReducer
